<template>
  <div class="financialAuditProcessSettings">
    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      :ellipsis="false"
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title"
        :name="menu.name"
      >
        <div class="multi-table" v-if="finished">
          <van-form
            label-width="120px"
            :show-error="false"
            :scroll-to-error="false"
            @failed="onFailed"
            @submit="onSubmit"
          >
            <van-field name="stepper" :label="$t.financialAuditProcessSettings.auditor">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="form.SettingList.length"
                  @plus="handleAdd"
                  :disable-minus="true"
                  :disable-input="true"
                />
              </template>
            </van-field>
            <div v-for="(item, index) in form.SettingList" :key="index">
              <div class="multi-table-header">
                <div class="multi-table-title"></div>
                <div class="multi-table-btn" @click="handleDelByIndex(index)">
                  <van-icon name="close" />
                </div>
              </div>
              <van-field
                :value="index + 1"
                :label="$t.financialAuditProcessSettings.level"
                readonly
              />
              <van-field
                v-model="item.Position"
                :label="$t.financialAuditProcessSettings.job"
                :name="$t.financialAuditProcessSettings.job"
                :placeholder="$t.meta.input"
                required
                :rules="formRule"
              />
              <van-field
                clickable
                readonly
                :value="item.ExecutionUserListText"
                :label="$t.financialAuditProcessSettings.charge"
                :name="$t.financialAuditProcessSettings.charge"
                type="textarea"
                rows="3"
                :placeholder="$t.meta.select"
                @click="
                  onShowEmit(
                    'showFinancialAuditProcessSettingsUser',
                    1,
                    item.ExecutionUserList,
                    index
                  )
                "
                required
                :rules="formRule"
              />
            </div>
            <div v-if="form.Cashier">
              <div class="multi-table-header">
                <div class="multi-table-title"></div>
              </div>
              <van-field
                :value="$t.financialAuditProcessSettings.cashier"
                :label="$t.financialAuditProcessSettings.level"
                readonly
              />
              <van-field
                :value="$t.financialAuditProcessSettings.cashier"
                :label="$t.financialAuditProcessSettings.job"
                readonly
              />
              <van-field
                clickable
                readonly
                :value="form.Cashier.ExecutionUserListText"
                :label="$t.financialAuditProcessSettings.charge"
                :name="$t.financialAuditProcessSettings.charge"
                type="textarea"
                rows="3"
                :placeholder="$t.meta.select"
                @click="
                  onShowEmit(
                    'showFinancialAuditProcessSettingsUser',
                    2,
                    form.Cashier.ExecutionUserList
                  )
                "
                required
                :rules="formRule"
              />
            </div>
            <div class="tool-bar" v-if="finished">
              <van-button type="info" block native-type="submit">{{
                $t.meta.save
              }}</van-button>
            </div>
          </van-form>
        </div>
      </van-tab>
    </van-tabs>

    <check-list
      event="showFinancialAuditProcessSettingsUser"
      :options="userList"
      :value="checkListValues"
      @onSelect="onSelectUser"
    ></check-list>
  </div>
</template>
<script>
import Vue from "vue";
import CheckList from "@components/checkList/CheckList.vue";
import { Tab, Tabs, Form, Field, Button, Icon, Stepper } from "vant";

Vue.use(Tab).use(Tabs).use(Form).use(Field).use(Button).use(Icon).use(Stepper);

export default {
  name: "financialAuditProcessSettings",
  components: {
    CheckList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      finished: false,
      level: "",
      menuState: 1,
      menuList: [
        {
          title: this.$t.financialAuditProcessSettings.tab1,
          name: 1,
        },
        {
          title: this.$t.financialAuditProcessSettings.tab2,
          name: 2,
        },
      ],
      form: {
        Cashier: {},
        SettingList: [],
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      userList: [],
      showUserPicker: false,
      itemIndex: 0,
      itemType: 1,
      checkListValues: [],
      checkListDisabled: [],
    };
  },
  watch: {
    menuState() {
      this.finished = false;
      this.tableData = [];
      this.getList();
    },
  },
  created() {
    this.getUserListByCondition().then((success) => {
      if (success) {
        this.getList();
      }
    });
  },
  methods: {
    getChecked(items) {
      var values = items;
      var result = [];
      if (values && values.length > 0) {
        for (var id of values) {
          result.push(id);
        }
      }
      this.checkListValues = result;
    },
    getDisabled(items) {
      var values = this.form.SettingList.reduce((acc, curr) => {
        return acc.concat(curr.ExecutionUserList);
      }, []);
      if (this.form.Cashier.ExecutionUserList.length > 0) {
        values = values.concat(this.form.Cashier.ExecutionUserList);
      }
      var disabled = [];
      for (var value of values) {
        if (items.find((item) => item == value)) {
        } else {
          disabled.push(value);
        }
      }
      for (var user of this.userList) {
        if (disabled.find((id) => id == user.value)) {
          user.disabled = true;
        } else {
          user.disabled = false;
        }
      }
    },
    onSelectUser(e) {
      if (this.itemType == 1) {
        var users1 = [];
        this.form.SettingList[this.itemIndex].ExecutionUserListText = e
          .map((option) => option.text)
          .join(" , ");
        for (var user of e) {
          if (user.value) {
            users1.push(user.value);
          }
        }
        this.form.SettingList[this.itemIndex].ExecutionUserList = users1;
      }
      if (this.itemType == 2) {
        var users2 = [];
        this.form.Cashier.ExecutionUserListText = e
          .map((option) => option.text)
          .join(" , ");
        for (var user of e) {
          if (user.value) {
            users2.push(user.value);
          }
        }
        this.form.Cashier.ExecutionUserList = users2;
      }
      this.$forceUpdate();
    },
    onShowEmit(emit, type, items, index) {
      this.itemType = type;
      if (type == 1) {
        this.itemIndex = index;
      }
      this.getChecked(items);
      this.getDisabled(items);
      setTimeout(() => {
        this.$bus.$emit(emit, true);
      }, 100);
      this.$forceUpdate();
    },
    handleAdd() {
      this.form.SettingList.push({
        Position: "",
        ExecutionUserListText: "",
        ExecutionUserList: [],
      });
    },
    handleDelByIndex(index) {
      this.form.SettingList.splice(index, 1);
    },
    stateChanged(state) {
      this.menuState = state;
    },
    getList() {
      this.$commonMethod.showLoading();
      var param = {
        ApprovalType: this.menuState,
      };
      this.$api.systemManagement
        .getFinancialAuditProcessSettingsList(param)
        .then((res) => {
          var data = res.data;
          this.level = data.Level;
          var settings = data.SettingList;
          for (var index in settings) {
            //出纳员
            if (settings[index].FAPId == 1) {
              this.form.Cashier = settings[index];
              settings.splice(index, 1);
              if (this.form.Cashier && this.form.Cashier.ExecutionUserList.length > 0) {
                var cashiers = [];
                for (var userId of this.form.Cashier.ExecutionUserList) {
                  var user = this.userList.find((c) => c.value == userId);
                  if (user) {
                    cashiers.push(user);
                  }
                }
                if (cashiers.length > 0) {
                  this.form.Cashier.ExecutionUserListText = cashiers
                    .map((option) => option.text)
                    .join(" , ");
                }
              }
            }
            //其他审核员
            if (settings[index] && settings[index].ExecutionUserList.length > 0) {
              var users = [];
              for (var userId of settings[index].ExecutionUserList) {
                var user = this.userList.find((c) => c.value == userId);
                if (user) {
                  users.push(user);
                }
              }
              if (users.length > 0) {
                settings[index].ExecutionUserListText = users
                  .map((option) => option.text)
                  .join(" , ");
              }
            }
          }
          this.finished = true;
          this.form.SettingList = settings;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onSubmit() {
      var param = {
        ApprovalType: this.menuState,
        SettingList: [],
        Cashier: {
          FAPId: this.form.Cashier.FAPId,
          ExecutionUserList: this.form.Cashier.ExecutionUserList,
        },
      };
      for (var setting of this.form.SettingList) {
        param.SettingList.push({
          Position: setting.Position,
          ExecutionUserList: setting.ExecutionUserList,
        });
      }
      this.$commonMethod.showLoading();
      this.$api.systemManagement
        .addFinancialAuditProcessSettings(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.getList();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].name + " " + errorInfo.errors[0].message,
        });
      }
    },
    getUserListByCondition() {
      return new Promise((resolve) => {
        this.$api.systemManagement
          .getUserListByCondition({
            CompanyId: this.CompanyId,
            IsUse: 1,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.UserName,
                value: parseInt(item.UserId),
                disabled: false,
              };
              result.push(data);
            });
            this.userList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.financialAuditProcessSettings {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
